export default __webpack_public_path__ + "static/media/usertick.2a5398d2.svg";